import { render, staticRenderFns } from "./crm.vue?vue&type=template&id=72727856"
import script from "./crm.vue?vue&type=script&lang=js"
export * from "./crm.vue?vue&type=script&lang=js"
import style0 from "./crm.vue?vue&type=style&index=0&id=72727856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports